module.exports = __webpack_public_path__ + "img/category-14.9fcd057b.svg";